/**
 * Syntax colours inside diffs: the file's language highlights each hunk's rows (old and new
 * lines in order), and `paint` merges a row's tokens with its word-level change segments so both
 * show at once (design-language §6: diffs are syntax-highlighted).
 */
import { languageFromPath } from './diff.js';
import { isHighlightable } from './highlight.js';
/** The highlighter language for a path, or undefined (plain text). */
export function langForPath(path) {
    const lang = languageFromPath(path);
    return lang && isHighlightable(lang) ? lang : undefined;
}
/** Splits tokens at segment boundaries: every piece keeps its token colour and change flag. */
export function paint(text, tokens, segments) {
    const toks = tokens?.length ? tokens : [{ content: text }];
    const segs = segments?.length ? segments : [{ text, changed: false }];
    const out = [];
    let ti = 0;
    let tOff = 0;
    let si = 0;
    let sOff = 0;
    while (ti < toks.length && si < segs.length) {
        const t = toks[ti];
        const s = segs[si];
        const tLeft = t.content.length - tOff;
        const sLeft = s.text.length - sOff;
        if (tLeft <= 0) {
            ti++;
            tOff = 0;
            continue;
        }
        if (sLeft <= 0) {
            si++;
            sOff = 0;
            continue;
        }
        const n = Math.min(tLeft, sLeft);
        const piece = t.content.slice(tOff, tOff + n);
        const color = t.dark;
        const italic = !!t.fontStyle && (t.fontStyle & 1) > 0;
        const last = out.at(-1);
        if (last && last.color === color && last.changed === s.changed && last.italic === italic)
            last.text += piece;
        else
            out.push({ text: piece, ...(color ? { color } : {}), italic, changed: s.changed });
        tOff += n;
        sOff += n;
    }
    return out;
}
//# sourceMappingURL=diff-tokens.js.map